module.exports = __webpack_public_path__ + "img/60m10.f2c05611.jpg";